import { isUnionMatch } from 'src/models/applicant/resume/lib/common/object';

import { ApiConditionsErrors, ApiSuccess } from 'src/models/applicant/resume/api';

export const isSuccess = isUnionMatch<ApiSuccess | ApiConditionsErrors, ApiSuccess>('resume');
export const isConditionsErrors = isUnionMatch<ApiSuccess | ApiConditionsErrors, ApiConditionsErrors>('errors');
